export const PensData = [
    {
        title: "Sister in a Circle",
        tagline: "Did the btn styling and decided to brag about my incredible sister!",
        html: `<iframe height="400" style="width: 100%;" scrolling="no" title="Sister In A Circle" src="https://codepen.io/dberrymandev/embed/preview/xxLpKLN?default-tab=result" frameborder="no" loading="lazy" allowtransparency="true" allowfullscreen="true">
                See the Pen <a href="https://codepen.io/dberrymandev/pen/xxLpKLN">
                Sister In A Circle</a> by Daniel (<a href="https://codepen.io/dberrymandev">@dberrymandev</a>)
                on <a href="https://codepen.io">CodePen</a>.
            </iframe>`
    },
    {
        title: "Rocket to the Edge",
        tagline: "Learning CSS Positioning",
        html: `<iframe height="400" style="width: 100%;" scrolling="no" title="Rocket to the Edge" src="https://codepen.io/dberrymandev/embed/preview/wOwdXz?default-tab=result" frameborder="no" loading="lazy" allowtransparency="true" allowfullscreen="true">
                See the Pen <a href="https://codepen.io/dberrymandev/pen/wOwdXz">
                Rocket to the Edge</a> by Daniel (<a href="https://codepen.io/dberrymandev">@dberrymandev</a>)
                on <a href="https://codepen.io">CodePen</a>.
            </iframe>`
    },
    {
        title: "Mondrian",
        tagline: "",
        html: `<iframe height="400" style="width: 100%;" scrolling="no" title="CSS Positioning Exercise - Mondrian" src="https://codepen.io/dberrymandev/embed/preview/wNbrvd?default-tab=result" frameborder="no" loading="lazy" allowtransparency="true" allowfullscreen="true">
                See the Pen <a href="https://codepen.io/dberrymandev/pen/wNbrvd">
                CSS Positioning Exercise - Mondrian</a> by Daniel (<a href="https://codepen.io/dberrymandev">@dberrymandev</a>)
                on <a href="https://codepen.io">CodePen</a>.
            </iframe>`
    },
    {
        title: "Tree Topper",
        tagline: "",
        html: `<iframe height="400" style="width: 100%;" scrolling="no" title="Tree Topper" src="https://codepen.io/dberrymandev/embed/preview/NWRgmQg?default-tab=result" frameborder="no" loading="lazy" allowtransparency="true" allowfullscreen="true">
                See the Pen <a href="https://codepen.io/dberrymandev/pen/NWRgmQg">
                Tree Topper</a> by Daniel (<a href="https://codepen.io/dberrymandev">@dberrymandev</a>)
                on <a href="https://codepen.io">CodePen</a>.
            </iframe>`
    }
];